import React, { useEffect, useState } from "react";
import { Parallax } from "react-parallax";
import axios from "axios";
import image2 from "../Assets/page-background-5.jpg";
import Footer from "./Footer";
import Header from "./Header";
// import image1 from "../Assets/home_shasti.png";
import { Link } from "react-router-dom";
import CrackersLoader from './CrackersLoader';


function About() {
  const [aboutData, setAboutData] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 

 
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(" https://dharshancrackers.com/customer_api/content.php");
        const { body } = response.data;
        setAboutData(body.about);
        setContactData(body.contact);
      } catch (error) {
        console.error("Error fetching the about data", error);
      }finally {

        setIsLoading(false);

      }
    };

    fetchAboutData();
  }, []);

  // Fallback content if data is not loaded
  if (isLoading) {
    return <CrackersLoader />; // Show the custom loader while fetching data
  }

  

  return (
    <div>
      <div className="main-homepage">
        <Header />

        {/* Parallax Section */}
        <Parallax
          bgImage={image2}
          bgImageAlt="the cat"
          // strength={500}
          style={{ minHeight: "200px" }}
          
        >
          <div style={{ height: "230px" }}>
            <h1
              style={{
                color: "black",
                paddingTop: "100px",
                textAlign: "center",
              }}
            >
              About
            </h1>
            <p
              style={{
                display: "flex",
                justifyContent: "center",
                color: "black",
              }}
            >
              <Link to="/" style={{color:"black"}}>
              Home</Link> <i className="bi bi-chevron-right"></i> About Us
            </p>
          </div>
         
        </Parallax>
   
   {/* <div className="wave-top-about">
    <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path 
        fill="#aec0d0ff"
        d="
          M0,100 
          Q50,20 100,100 
          Q150,0 230,100 
          Q290,30 350,100 
          Q410,10 470,100 
          Q550,40 600,100 
          Q670,0 750,100 
          Q810,20 870,100 
          Q940,0 1020,100 
          Q1080,30 1140,100 
          Q1220,10 1300,100 
          Q1350,20 1440,100 
          L1440,0 
          L0,0 
          Z"
      />
    </svg>
  </div> */}

        <div className="about-section">
          
          {/* Top Image */}
          {/* <div className="topimg">
            <img src={image1} alt="" />
          </div> */}
          {/* Content aligned to the right */}
          <div className="content-text">
            <h5 style={{fontWeight:"bold"}}>Our Shop Details</h5>
            <br />
            <h3 style={{ letterSpacing: "2px", color: "darkblue" }}>
            DHARSAN CRACKERS
            </h3>
            <h4>
              WHOLESALE & RETAIL SHOP IN{" "}
              <span style={{ color: "darkred" }}>METTAMALAI</span>
            </h4>
            <br />
            {/* <p style={{ fontFamily: " Arial, Helvetica, sans-serif" }}>
              {aboutData.description}
            </p> */}

            <p
              style={{ fontFamily: " Arial, Helvetica, sans-serif" }}
              dangerouslySetInnerHTML={{ __html: aboutData.value }}
            />
            <br />
            <hr />
            <div>
              <h3>
                Call To Ask Any Enquiry{" "}
                <span style={{ color: "red" }}> {contactData.whatsapp_number}</span>
              </h3>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      
      <div className="minifooter1">
      <div className="minimenu">
          
      <Link to="/">
            <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-house-door" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
             Home
             </div>
             </Link>
         
             <Link to="/about">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-journal-text officon" style={{marginLeft:"20px",fontSize:"1.4rem",color:"white"}}></i>
             About Us
             </div>
             </Link>

             
          <Link to="/quick">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-bag" style={{marginLeft:"18px",fontSize:"1.4rem"}}></i>
             Enquiry
             </div>
             </Link>
             
            
         
          <Link to="/contact">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-telephone" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
             Contact
             </div>
             </Link>
          
        </div>
      </div>
    </div>
  );
}

export default About;
